import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, Label, Image} from "semantic-ui-react"
import {Row, Col, Form, FormField, FormInput} from "elemental-react16"
import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import { Table } from "semantic-ui-react";
import Responsive from "react-responsive"

@withRouter
export default class LoginPage extends Component {
	constructor() {
		super()
		this.state = {
			user    : "",
			password: "",
			forgetPassword: false
		}
		shop.whoami()
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.login( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then( session => {
				if ( !session ) return
				shop.loadCategories()
				shop.cart.hydrate()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				console.log( "AFTER", redirectTo )
				console.log( "SESSION", shop.session )
				if(shop.session.handUser){
					history.push( "/return/admin" )
				}
				else{
					history.push( "/return" )
				}
				/*if ( redirectTo ) {
					history.push( redirectTo )
				} else {*/
				//}
			} )

		e.preventDefault()
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}



	handleModalPassword = () => {
		this.setState(prevState => ({
			forgetPassword: !prevState.forgetPassword
		}));
		console.log("forgetPassword", this.state.forgetPassword);
	};

	render() {
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		return (
			<Fragment>
				<Responsive minWidth={790}>
				<div className="LoginPage pb6">
				<div className=" container">
					<div className="black absolute top-0 right-2 pt2">
						<LanguageDropdown />
					</div>

					<section>
						<Row>
							<Col className="tc pb4"
								 style={{marginTop: "20px"}}>
								<Link className={"logo"} to="/login/">
									<img
										src={shop.config.logo}
										alt="" />
								</Link>
							</Col>
						</Row>
					</section>

					<WordPressContainer postType={"shop"} slug={"login"} />
					<section className="container pb4" style={{width:"35%"}}>
					<Image src={"/BH_logo_lang.svg"} alt="TEST" />
					<Table>
						<colgroup>
							<col width="100%" />
						</colgroup>
						<thead />
						<tbody>
							<tr className="pl7">
								<td>

								<h1 style={{color:"#265a88"}} className="tc pt4">Anmeldung Paketretoure</h1>
								<Row className="pl4 pr3">
						<Col  sm="11/12"> </Col>
						<Col  sm="11/12">
							<div className="mw6"
								 style={{marginTop: "10px"}}>
								<Form onSubmit={this.handleLogin}>
									<div >GLN/ILN-Nummer</div>
									<FormField  className="FormFieldLogin" label={<p className="" style={{fontSize:11,paddingBottom:"0px"}}>{translate("(Ihre GLN/ILN-Nummer finden Sie in Ihren Unterlagen)")}</p>}
											   title={translate("Anmeldung mit GLN/ILN-Nummer.")}
											   htmlFor="basic-form-input-email">
										<FormInput value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={translate("GLN/ILN-Nummer.")}
												   name="basic-form-input-id" />
									</FormField>
									<div>Passwort</div>
									<FormField label={<p style={{fontSize:11}}>{translate("(Bitte geben Sie hier Ihre Postleitzahl ein)")}</p>}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tr pt3">
										<Button
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										{/*<a className="db mt3"
											  onClick={this.handleModalPassword} >{translate( "Passwort vergessen" )}</a> */}
									</div>
								</Form>
							</div>
						</Col>
					</Row>
								</td>
							</tr>
						</tbody>
							
					</Table>
					{
					<Table>
						<Row className="pl4 pr3">
						<Col  sm="11/12">
							<p style={{fontSize:15}} className="pb2 pt4">Falls Sie Schwierigkeiten bei der Anmeldung haben und/oder weitere Fragen zur Paketretoure, wenden Sie sich bitte an unsere Service-Hotline. Diese ist Montag - Donnerstag in der Zeit von 8:00 – 16:00 Uhr sowie Freitag von 8:00 – 13:00 Uhr unter der Telefonnummer 05641 95124 gerne für Sie erreichbar.</p>
						</Col>
						</Row>
						
					</Table>}
					</section>
					<hr />

					<div className="center mw6 pb3">
						{/*<Message>
							<div className="b">{translate("LOGIN_NOTICE_HEADER")}</div>

							<div>{translate("LOGIN_NOTICE")}</div>

							<div className={"tc pt3"}>
								<Button as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
							</div>
						</Message>*/}
					</div>

					{/*<div className="tc pb5">
						<div className="black-50">{translate( "No account yet?" )}</div>
						<Link to="/customer_registration">{translate( "register new account" )}</Link> <br />
						{config.customer_enabling &&
						<Link to="/customer_enabling">{translate( "access with offline account" )}</Link>}
					</div>*/}

					{config.b2cLink && <div>
						<hr />
						<div className="tc">
							<a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
						</div>
					</div>}
				</div>

				<div className="bg-silver fixed bottom-0 left-0 right-0">

					<Menu fluid
						  secondary
						  size="small">
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
								   position="right">{translate( "Data Policy" )}</Menu.Item>
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "agb"} )}}>AGB</Menu.Item>
					</Menu>

				</div>


				<Modal
					open={query.modal && query.slug}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug={query.slug} />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "data"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="datenschutz" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "imprint"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="impressum" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "agb"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="agb" />
					</Modal.Content>
				</Modal>
			</div>
				</Responsive>
				<Responsive maxWidth={789}>
				<section>
						{/*<Row>
							<Col className="tc pb4"
								 style={{marginTop: "20px"}}>
								<Link className={"logo"} to="/login/">
									<img
										src={shop.config.logo}
										alt="" />
								</Link>
							</Col>
						</Row> */}
						<div className="pt3 pl4 pr4"><Image src={"/BH_logo_lang.svg"} alt="TEST" /></div>
					</section>
					<div className="pa3">
					<table className="ba">
						<colgroup>
							<col width="100%" />
						</colgroup>
						<thead />
						<tbody>
							<tr className="pl7">
								<td>
								<h1 style={{color:"#265a88"}} className="tc pt4">Anmeldung</h1>
								<Row className="pl4 pr3">
						<Col  sm="11/12"> </Col>
						<Col  sm="11/12">
							<div className="mw6"
								 style={{marginTop: "10px"}}>
								<Form onSubmit={this.handleLogin}>
									<div >GLN/ILN-Nummer</div>
									<FormField  className="FormFieldLogin" label={<p className="" style={{fontSize:11,paddingBottom:"0px"}}>{translate("(Ihre GLN/ILN-Nummer finden Sie in Ihren Unterlagen)")}</p>}
											   title={translate("Anmeldung mit GLN/ILN-Nummer.")}
											   htmlFor="basic-form-input-email">
										<FormInput value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={translate("GLN/ILN-Nummer.")}
												   name="basic-form-input-id" />
									</FormField>
									<div>Passwort</div>
									<FormField label={<p style={{fontSize:11}}>{translate("(Bitte geben Sie hier Ihre Postleitzahl ein)")}</p>}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tc pt3">
										<Button
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										{/*<a className="db mt3"
											  onClick={this.handleModalPassword} >{translate( "Passwort vergessen" )}</a>*/}
									</div>
								</Form>
							</div>
						</Col>
					</Row>
								</td>
							</tr>
						</tbody>
							
					</table>
					</div>
					{<div className="pa3 ">
					<table className="ba">
						<Row className="pl4 pr3">
						<Col  sm="11/12">
							<p style={{fontSize:15}} className="pb2 pt4">Falls Sie Schwierigkeiten bei der Anmeldung haben und/oder weitere Fragen zur Paketretoure, wenden Sie sich bitte an unsere Service-Hotline. Diese ist Montag - Donnerstag in der Zeit von 8:00 – 16:00 Uhr sowie Freitag von 8:00 – 13:00 Uhr unter der Telefonnummer 05641 95124 gerne für Sie erreichbar.</p>
						</Col>
						</Row>
						
					</table>
					</div>}
				</Responsive>
			</Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/LoginPage.js